export default __webpack_public_path__ + "media/images/back-95b542c448da250a27ee28b5f46d8e69.png";